"use strict";

const BC_FileExport = function (EWS) {
    this.EWS = EWS;
    this.GoogleAttempts = 0;

    const me = this;
    let IsSubmit = false;

    EWS.Command.AddMenu("BC_FileExport_ExportMenu", (control, name, menu, callback) => {
        menu.innerHTML = "";

        callback(control, menu);
    }, (control, name, menu, menuArgs) => {
        if (!IsSubmit) {
            // Task 969413: JavaScript Error: DashboardID=100120 (0) - TypeError: Cannot read property 'replaceChild' of null
            IsSubmit = true;
            menu.style.display = "none";
            menu.innerHTML = "";

            const processUrlCallback = menuArgs.processUrlCallback;
            const processGoogleCallback = menuArgs.processGoogleCallback;
            // Task 916478: Report Print: Print Preview is different in 21.02 than in 20.09. Printing the same report Driver Manifest 5.1 has different layouts in different ECP
            let customOptions = menuArgs.customOptions;

            EWS.VerifySession(() => {
                const myRequest = new ECP.EC_Request("FileExport_ExportMenu");
                // Task 757605: I still have an issue with one of my other saved reports. When I try to export the file I get an error code 'error in promise'
                myRequest.AddRequestVariable("Url", menuArgs.url, ECP.EC_Verb.Post);
                if (!EC_Fmt.isNull(menuArgs.formats)) {
                    myRequest.AddRequestVariable("Formats", menuArgs.formats);
                }
                myRequest.Submit().then((result) => {
                    let html = "";
                    const options = EWS.Json.Query(result, "$.options[?(@.format != 'WebQuery')]");

                    for (let i = 0; i < options.length; i++) {
                        html += `<div class=ews-menu-item url="${options[i].url}" format="${options[i].format}" `;
                        let temp = "";
                        if (document.getElementById("ActionButtonExport") && document.getElementById("ActionButtonExport").getAttribute("onclick")) {
                            temp += document.getElementById("ActionButtonExport").getAttribute("onclick");
                        }
                        if (document.getElementById("ActionButtonDownload") && document.getElementById("ActionButtonDownload").getAttribute("onclick")) {
                            temp += document.getElementById("ActionButtonDownload").getAttribute("onclick");
                        }
                        if (options[i].format === "Google") {
                            temp += ";ECP.Dialog.ShowLoading('Exporting to Google Drive...');";
                        }
                        if (options[i].format === "BrowserPrint") {
                            temp = "";
                        }
                        html += `onclick="${temp}">`
                            + ` <div class="ews-menu-icon ews-icon-${options[i].icon}"></div>`
                            + ` <div class=ews-menu-label>${options[i].name}</div>`
                            + "</div>";
                    }

                    if (customOptions) {
                        if (!Array.isArray(customOptions)) {
                            customOptions = [customOptions];
                        }
                        for (let i = 0; i < customOptions.length; i++) {
                            const option = customOptions[i];

                            html += `<div class=ews-menu-item url sequence="${i}" format=Custom name="${EC_Fmt.HTMLEncode(option.name)}">`
                                  + ` <div class="ews-menu-icon ews-icon-${option.icon ? option.icon : "text"}"></div>`
                                  + ` <div class=ews-menu-label>${option.name}</div>`
                                  + "</div>";
                        }
                    }

                    const query = EWS.Json.Query(result, "$.options[?(@.format == 'WebQuery')]")[0];

                    if (query) {
                        html += "<div class=ews-menu-seperator></div>"
                            + `<div class=ews-menu-item url="${query.url}" format="${query.format}" `;
                        let temp = "";
                        if (document.getElementById("ActionButtonExport") && document.getElementById("ActionButtonExport").getAttribute("onclick")) {
                            temp += document.getElementById("ActionButtonExport").getAttribute("onclick");
                        }
                        if (document.getElementById("ActionButtonDownload") && document.getElementById("ActionButtonDownload").getAttribute("onclick")) {
                            temp += document.getElementById("ActionButtonDownload").getAttribute("onclick");
                        }
                        html += `onclick="${temp}">`
                            + `<div class=ews-menu-label>${query.name}</div>`
                            + "</div>";
                    }

                    menu.innerHTML = html;
                    menu.style.display = "block";

                    menu = EC_Fmt.RemoveAllEventListeners(menu);

                    menu.addEventListener("click", (event) => {
                        const trigger = event.target.closest(".ews-menu-item");

                        if (trigger) {
                            const format = trigger.getAttribute("format");
                            let url = trigger.getAttribute("url");

                            if (processUrlCallback) {
                                url = processUrlCallback(url, format);
                            }

                            // Task 1033298: Adding Google Analytics as a default feature of dashboards
                            gtag("event", "share", { content_type: format });

                            switch (format) {
                                case "Google":
                                    me.AuthGoogle(url, null, processGoogleCallback);
                                    break;

                                case "Print":
                                    Print_Preview(trigger.getAttribute("url"), "XLSX", null, null, processUrlCallback);
                                    break;

                                case "WebQuery":
                                    const PostData = new FormData();

                                    PostData.append("Format", "WebQuery");
                                    PostData.append("Lifetime", "180");
                                    PostData.append("Impersonate", "True");
                                    PostData.append("Url", url.replace("Format=WebQuery", ""));

                                    EWS.VerifySession(() => {
                                        fetch("api?APICommand=QuickLinkAjax&Requests=Generate", {
                                            credentials: "same-origin",
                                            method: "POST",
                                            body: PostData
                                        }).then(response => response.json()).then((responseJson) => {
                                            window.location.href = responseJson.url;
                                        });
                                    });
                                    break;
                                case "BrowserPrint":
                                    menu.style.display = "none";
                                    window.print();
                                    break;

                                case "Custom":
                                    const sequence = EC_Fmt.Null2ZeroInt(trigger.getAttribute("sequence"));
                                    const option = customOptions[sequence];
                                    if (option?.processCallback) {
                                        option.processCallback();
                                        break;
                                    }
                                    break;

                                default:
                                    let title = document.getElementsByTagName("title");
                                    if (title.length > 0) {
                                        title = title[0].innerHTML;
                                    }
                                    EC_Fmt.DownloadFileFromURL(url, EC_Fmt.Null2EmptyStr(title));

                                    // Task 661168: Adding a download file animation
                                    menu.style.display = "block";

                                    const originalIcon = trigger.querySelector("div.ews-menu-icon");
                                    const originalPosition = originalIcon.getBoundingClientRect();

                                    const animationContainer = document.createElement("div");
                                    animationContainer.classList.add("ews-menu");
                                    animationContainer.setAttribute("style", `position:fixed;display:block;top:${originalPosition.top}px;left:${originalPosition.left}px;z-index:10001;color:var(--text)`);
                                    const icon = document.createElement("div");
                                    animationContainer.appendChild(icon);

                                    document.body.appendChild(animationContainer);
                                    icon.setAttribute("style", `position:fixed;display:block;top:${originalPosition.top}px;left:${originalPosition.left}px;z-index:10001;color:var(--text)`);
                                    icon.classList = originalIcon.classList;
                                    icon.innerHTML = ` ${title}`;
                                    requestAnimationFrame(() => {
                                        icon.classList.add("ews-menu-icon-download-animation");
                                        setTimeout(() => {
                                            menu.style.display = "none";
                                            document.body.removeChild(animationContainer);
                                        }, 1000);
                                    });

                                    break;
                            }
                            // Task 694365: After clicking Export --> Print, do not hide
                            if (menu) {
                                menu.style.display = "none";
                            }
                        }
                    });
                    IsSubmit = false;
                });
            }, true, null, () => {
                // Task 604081: Export and print buttons do nothing on Quicklinks reports - Add option to login when clicking those buttons
                ECP.Dialog.ShowDialog("Confirm", `<div style=font-size:16px;margin:auto;min-height:117px;display:flex;flex-direction:column;align-items:center;justify-content:center><span>You are impersonating a user.</span></span>Do you want to leave and go back to your login?</span></div>`, {
                    cancelButtonTitle: "Cancel",
                    confirmButtonTitle: "OK",
                    confirmButtonAction: () => {
                        window.location.href = `Home?DashboardID=${ECP.CommonDashboards.LogOn}&DestURL=${encodeURIComponent(window.location.href)}`;
                    }
                });
            });
        }
    });
};

BC_FileExport.prototype.AuthGoogle = function (url, login, processGoogleCallback) {
    if (EC_Fmt.isMobile) {
        ECP.Dialog.HideLoading();
        url = url.replace("Format=Google", "Format=Excel");
        ECP.Dialog.Alert("<div style=padding:7px;text-align:left!important><b>To export to Google Drive from mobile:"
            + `<br>1) Select '<span class=ews-menu-item style=color:var(--text-link);text-decoration:underline onclick="EC_Fmt.DownloadFileFromURL('${url}');">Export to Excel</span>'`
            + "<br>2) Click the 'Share' button in the browser"
            + "<br>3) Select 'Copy to Sheets'"
            + "</div>"
            + "<br>This requires the Google Sheets app to already be installed.</b>");
    } else {
        const me = this;

        if (this.GoogleAttempts < 5) {
            EWS.Load("https://apis.google.com/js/client.js?onload=handleClientLoad", () => {
                if (gapi?.client && gapi?.auth) {
                    const myRequest = new ECP.EC_Request("FileExport_GetKeys");
                    myRequest.Submit().then((result) => {
                        me.Keys = result;

                        // Task 705496: Cannot Export to Google Drive, or perform Table Import from Google Drive.
                        gapi.auth2.authorize({
                            client_id: me.Keys.google.client,
                            scope: me.Keys.google.scope
                        }, (googleResult) => {
                            if (googleResult.error) {
                                me.GoogleAttempts += 1;
                                ECP.Dialog.HideLoading();
                                ECP.Dialog.Alert("<span><b>You Must Login to a Google Account in order to export to Google Drive.</b><br>Login via the popup.<br>If no popup is displayed, make sure popups are not blocked for this site.</span>");
                                return;
                            }

                            if (googleResult.access_token) {
                                me.GoogleAttempts = 0;
                                const tokenName = processGoogleCallback ? "GoogleToken" : "Token";

                                if (url.indexOf("?") >= 0 && !url.endsWith("&")) {
                                    url += `&${tokenName}=${googleResult.access_token}`;
                                } else if (url.indexOf("?") >= 0) {
                                    url += `${tokenName}=${googleResult.access_token}`;
                                } else {
                                    url += `?${tokenName}=${googleResult.access_token}`;
                                }

                                if (processGoogleCallback) {
                                    fetch(url, {
                                        credentials: "same-origin"
                                    }).then(response => response.json()).then((data) => {
                                        ECP.Dialog.HideLoading();
                                        processGoogleCallback(data);
                                    });
                                } else {
                                    window.location.href = url;
                                }
                            }
                        });

                        gapi.client.setApiKey(me.Keys.google.app);
                    });
                } else {
                    ECP.Dialog.HideLoading();
                    ECP.Dialog.Alert("Google Drive is unavailable. Please try again later.");
                }
            });
        } else {
            ECP.Dialog.HideLoading();
            ECP.Dialog.Alert("Unable to login to Google.");
        }
    }
};

BC_FileExport.prototype.Google = function (file, name, callback, login) {
    let immediate = true;

    if (login) {
        immediate = false;
    }

    const me = this;

    if (this.GoogleAttempts < 5) {
        EWS.Load("https://apis.google.com/js/client.js?onload=handleClientLoad", () => {
            if (gapi?.client && gapi?.auth) {
                const myRequest = new ECP.EC_Request("FileExport_GetKeys");
                myRequest.Submit().then((googleResult) => {
                    me.Keys = googleResult;

                    gapi.auth.authorize({
                        client_id: me.Keys.google.client,
                        scope: me.Keys.google.scope,
                        immediate
                    }, (googleAuthResult) => {
                        me.GoogleAttempts += 1;

                        if (googleAuthResult && !googleAuthResult.error) {
                            me.GoogleAttempts = 0;

                            if (googleAuthResult.access_token) {
                                me.UploadGoogle(file, name, googleAuthResult.access_token, callback);
                            }
                        } else {
                            me.Google(file, name, callback, true);
                        }
                    });

                    gapi.client.setApiKey(me.Keys.google.app);
                });
            } else {
                ECP.Dialog.Alert("Google Drive is unavailable. Please try again later.");
            }
        });
    } else {
        ECP.Dialog.Alert("Unable to login to Google.");
    }
};

BC_FileExport.prototype.UploadGoogle = function (file, name, token, callback) {
    ECP.Dialog.ShowLoading();

    const myRequest = new ECP.EC_Request("FileExport_UploadGoogle");
    myRequest.AddRequestVariable("File", file, ECP.EC_Verb.Post);
    myRequest.AddRequestVariable("Token", token, ECP.EC_Verb.Post);
    myRequest.Submit().then((googleResult) => {
        ECP.Dialog.HideLoading();

        try {
            googleResult = JSON.parse(googleResult);

            if (googleResult.status === "success") {
                if (!EC_Fmt.isNull(callback)) {
                    callback();
                }
            } else {
                ECP.Dialog.Alert(googleResult.message);
            }
        } catch (error) {
            ECP.Dialog.Alert(`${error}\n${googleResult}`);
        }
    }).catch((error) => {
        ECP.Dialog.HideLoading();
        throw error;
    });
};

BC_FileExport.prototype.ExportMenu = function (trigger, url, formats, processUrlCallback, processGoogleCallback, customOptions) {
    EWS.Command.ShowMenu("BC_FileExport_ExportMenu", trigger, {
        url,
        formats,
        processUrlCallback,
        processGoogleCallback,
        customOptions
    });
};

(function (EWS) {
    // eslint-disable-next-line no-shadow
    EWS.Ready((EWS) => {
        EWS.FileExport = new BC_FileExport(EWS);
    });
}(EWS));

// eslint-disable-next-line no-unused-vars
function FileExport_Menu(trigger, url, formats, processUrlCallback, processGoogleCallback, customOptions) {
    if (EWS?.FileExport) {
        EWS.FileExport.ExportMenu(trigger, url, formats, processUrlCallback, processGoogleCallback, customOptions);
    }
}
